import { createPluginOptions } from "../create-plugin-options";

export const defaultEventListOptions = createPluginOptions()({
	oplVisible: false,
});

export type EventListOptions = typeof defaultEventListOptions;
